import { render, staticRenderFns } from "./SupportItem.vue?vue&type=template&id=243a684f&scoped=true&"
import script from "./SupportItem.vue?vue&type=script&lang=js&"
export * from "./SupportItem.vue?vue&type=script&lang=js&"
import style0 from "./SupportItem.vue?vue&type=style&index=0&id=243a684f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a684f",
  null
  
)

export default component.exports